export { getEventTarget } from '@fluentui/dom-utilities';
